import { I18nProvider } from "@magic-md/i18n/react";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useSettingsStore } from "../store/settings-store";

export function WorkbenchI18nProvider({
    children,
}: {
    children: ReactNode;
}) {
    const ensureLoaded = useSettingsStore((state) => state.ensureLoaded);
    const requestedLocale = useSettingsStore((state) => {
        const value = state.snapshot?.view.values["editor.locale"];
        return typeof value === "string" ? value : "auto";
    });

    useEffect(() => {
        void ensureLoaded();
    }, [ensureLoaded]);

    return <I18nProvider locale={requestedLocale}>{children}</I18nProvider>;
}
